import { render, staticRenderFns } from "./PopoverTarget.vue?vue&type=template&id=1a9cce39&scoped=true&"
import script from "./PopoverTarget.vue?vue&type=script&lang=ts&"
export * from "./PopoverTarget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9cce39",
  null
  
)

export default component.exports